export interface SurveyResponse {
  questionId: string;
  optionValue: string;
}

export interface SelectedStarRating {
  questionId: string;
  stars: number;
}

export const getMergedSurveyResponse = (
  prevResponses: SurveyResponse[],
  selectedRating: SurveyResponse,
) => {
  const index = prevResponses.findIndex(
    (response) => response.questionId === selectedRating.questionId,
  );
  if (index !== -1) {
    const updatedResponses = [...prevResponses];
    updatedResponses[index] = selectedRating;
    return updatedResponses;
  }
  return [...prevResponses, selectedRating];
};

export const getIsStarFilled = (
  star: string,
  questionId: string,
  rating: SelectedStarRating[],
  hoverRating: SelectedStarRating[],
) => {
  const getStars = (list: SelectedStarRating[]) =>
    list.find((item) => item.questionId === questionId)?.stars;

  const value = getStars(hoverRating) ?? getStars(rating);
  return Number(star) <= (value ?? 0);
};
